import { forwardRef, ReactNode } from "react";
import { Stack, useTheme } from "@mui/material";
import { TiledBackground } from "../theme/background";

interface TopBarProps {
    children: ReactNode | ReactNode[];
}

const topContainerStyle = {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    padding: "10px",
    zIndex: 1000,
}

export const TopBar = forwardRef<HTMLDivElement, TopBarProps>((props, ref) => {
    const theme = useTheme();

    return (
        <Stack
            ref={ref}
            direction={"row"}
            alignItems={"center"}
            spacing={1}
            sx={{
                ...topContainerStyle,
                background: theme.bee.barBackground,
            }}>
            <TiledBackground offset={0} />
            {props.children}
        </Stack>
    )
})